module.exports = __webpack_public_path__ + "img/book4.f472592.png";